export const TRUCK_RESERVATION_TYPES = [
    { value: 'reserve', i18n: 'Reserve' },
    { value: 'book', i18n: 'Book' },
    { value: 'cancel', i18n: 'Cancel' },
    { value: 'waiting_for_production', i18n: 'Waiting For Production' }
]
